import React from 'react';
import swal from 'sweetalert';
import { GridCell } from '@progress/kendo-react-grid';

export default function CellWithEditing(edit, toggleActive) {
	return class extends GridCell {
		render() {
			return (
                <td>
                    {/*console.log(this.props.dataItem)*/}
                    {this.props.dataItem.externalURL?
                        <button
                            className="admin-k-button adjust"
                            onClick={() => {
                                window.open(this.props.dataItem.externalURL);
                            }}
                        >
                            URL
					</button>
                        : <button
                            className="admin-k-button adjust"
                            onClick={() => {
                                window.open(this.props.dataItem.externalURL);
                            }}
                            disabled
                        >
                            URL
					</button>}
					<button
						className="admin-k-button "
						onClick={() => {
							edit(this.props.dataItem);
						}}
					>
						<i className="fas fa-pen"></i>
					</button>
					&nbsp;
					{this.props.dataItem.isActive ? (
						<button
							className="admin-k-button "
							onClick={() => {
								swal({
									title: 'Are you sure?',
									text: `Once deactivated, ${this.props.dataItem.title} will no longer be available.`,
									icon: 'warning',
									buttons: {
										cancel: 'CANCEL',
										confirm: 'YES'
									},
									dangerMode: true
								}).then((value) => (value ? toggleActive(this.props.dataItem) : null));
							}}
						>
							<i className="fas fa-times-circle"></i>
						</button>
					) : (
						<button
								className="admin-k-button activate-btn"
                                onClick={() => {
                                    swal({
                                        title: 'Are you sure?',
                                        text: `Are you sure you want to re-activate ${this.props.dataItem.title}?`,
                                        icon: 'warning',
                                        buttons: {
                                            cancel: 'CANCEL',
                                            confirm: 'YES'
                                        },
                                        dangerMode: true
                                    }).then((value) => (value ? toggleActive(this.props.dataItem) : null));
							}}
						>
							<i className="fas fa-check-circle"></i>
						</button>
					)}
				</td>
			);
		}
	};
}
